import {
  apiGetSchoolConflicts,
  apiResolveConflict
} from '../../common/api/school'

import { apiRetireStudent } from '../../common/api/student-management'

const fetchConflicts = schoolId => ({
  requestPrefix: 'CONFLICTS_STORE:FETCHING',
  request: () => apiGetSchoolConflicts(schoolId)
})

const refetchConflicts = schoolId => ({
  requestPrefix: 'CONFLICTS_STORE:REFETCHING',
  request: () => apiGetSchoolConflicts(schoolId)
})

const retireStudent = studentId => ({
  requestPrefix: 'CONFLICTS_STORE:RETIRE',
  request: () => apiRetireStudent(studentId)
})

const resolveConflict = (schoolId, matchingStudentId, legacyStudentId) => ({
  requestPrefix: 'CONFLICTS_STORE:RESOLVE',
  request: () =>
    apiResolveConflict(schoolId, {
      matching_student_id: matchingStudentId,
      legacy_student_id: legacyStudentId
    })
})

const setStep = step => ({
  type: 'CONFLICTS_STORE:SET_STEP_SUCCESS',
  step
})

export {
  fetchConflicts,
  refetchConflicts,
  retireStudent,
  resolveConflict,
  setStep
}
